import { forwardRef } from 'react';
import styled from 'foundations-theming/utils';
import { OAuthStyles } from './constants';
import { useOAuthButtonContext } from './OAuthButtonContext';
import { jsx as _jsx } from "react/jsx-runtime";
const ButtonWrapper = styled.button.withConfig({
  displayName: "Button__ButtonWrapper",
  componentId: "go0t3e-0"
})(["background:", ";border:", ";border-color:", ";border-radius:", ";color:", ";display:flex;align-items:center;justify-content:center;inline-size:100%;max-height:40px;height:40px;padding:0;box-shadow:", ";box-sizing:border-box;&:disabled{background-color:", ";border-color:", ";color:", ";cursor:not-allowed;}&:hover{background-color:", ";}"], ({
  useBrandColors,
  theme,
  provider
}) => useBrandColors ? OAuthStyles[provider].bgColor : theme.color['fill-surface-default'], ({
  useBrandColors
}) => useBrandColors ? 'solid 2px' : 'solid 1px', ({
  useBrandColors,
  theme,
  provider
}) => useBrandColors ? OAuthStyles[provider].borderColor : theme.color['border-core-default'], ({
  theme
}) => theme.borderRadius['200'], ({
  useBrandColors,
  theme,
  provider
}) => useBrandColors ? OAuthStyles[provider].textColor : theme.color['text-core-default'], ({
  theme
}) => theme.boxShadow['100'], ({
  theme
}) => theme.color['fill-secondary-disabled'], ({
  theme
}) => theme.color['border-secondary-disabled'], ({
  theme
}) => theme.color['text-secondary-disabled'], ({
  useBrandColors,
  theme,
  provider
}) => useBrandColors ? OAuthStyles[provider].hoverBgColor : theme.color['fill-tertiary-hover']);
export const Button = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    provider,
    useBrandColors
  } = useOAuthButtonContext();

  /* @bend-expect trellis-tokenized */
  return /*#__PURE__*/_jsx(ButtonWrapper, Object.assign({}, props, {
    ref: ref,
    provider: provider,
    useBrandColors: useBrandColors
  }));
});